import { useCallback, useEffect, useState } from "react";
import { EVENTO_LEITURA_NOVIDADES, lerNovidadesVistas } from "./leituraNovidades";

// Compartilha a leitura entre Ajuda, Atualizações e outras abas, por conta/perfil.
export function useNovidadesVistas(chave, open = false) {
  const [estado, setEstado] = useState(() => ({ chave, ids: lerNovidadesVistas(chave) }));
  const vistas = estado.chave === chave ? estado.ids : lerNovidadesVistas(chave);
  const setVistas = useCallback(atualizar => {
    setEstado(atual => {
      const ids = atual.chave === chave ? atual.ids : lerNovidadesVistas(chave);
      return { chave, ids: typeof atualizar === "function" ? atualizar(ids) : atualizar };
    });
  }, [chave]);

  useEffect(() => {
    setEstado(atual => ({ chave, ids: [...new Set([
      ...lerNovidadesVistas(chave), ...(atual.chave === chave ? atual.ids : []),
    ])] }));
    const sincronizarAba = event => {
      if (event.key === chave || event.key === null) setEstado({ chave, ids: lerNovidadesVistas(chave) });
    };
    const sincronizarPagina = event => {
      if (chave && event.detail?.chave === chave) setEstado({ chave, ids: event.detail.ids });
    };
    window.addEventListener("storage", sincronizarAba);
    window.addEventListener(EVENTO_LEITURA_NOVIDADES, sincronizarPagina);
    return () => {
      window.removeEventListener("storage", sincronizarAba);
      window.removeEventListener(EVENTO_LEITURA_NOVIDADES, sincronizarPagina);
    };
  }, [chave, open]);
  return [vistas, setVistas];
}
